/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import React, { useCallback, useEffect, useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import Paper from '@mui/material/Paper';
import StyledTableCell from '../../../../../../components/ui-elements/table/StyledTableCell';
import StyledTableRow from '../../../../../../components/ui-elements/table/StyledTableRow';
import { IconButton, Typography } from '@mui/material';
import { BsFillPencilFill } from 'react-icons/bs';
import { useDispatch, useSelector } from 'react-redux';
import DialogContainer from '../../../../../../components/shared/Dialog/DialogContainer';
import AppEdit from './AppEdit';
import Loader from '../../../../../../components/ui-elements/loader';
import ApplicationHistory from './ApplicationHistory';
import { FaHistory } from 'react-icons/fa';
import { getAllApplication } from '../../../../../../store/reducers/application/applicationAction';

const AppsList = () => {
    const [selectedApplication, setSelectedApplication] = useState({});
    const [openEditApplication, setOpenEditApplication] = useState(false);
    const [openHistoryApplication, setOpenHistoryApplication] = useState(false);
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const applications = useSelector(state => state.application.applications);

    const handleCloseDialog = () => {
        setOpenEditApplication(false);
        setOpenHistoryApplication(false);
    }

    const fetchApplication = useCallback(async () => {
        setLoading(true);
        try {
            await dispatch(getAllApplication()).unwrap();
            setLoading(false)
        } catch (error) {
            setLoading(false)
        }
    }, [dispatch]);
    useEffect(() => { fetchApplication() }, [fetchApplication])

    return (
        <>
            {!loading ? <TableContainer component={Paper}>
                <Table sx={{ minWidth: 700 }} aria-label="customized table">
                    <TableHead>
                        <StyledTableRow>
                            <StyledTableCell label="Application Name" />
                            <StyledTableCell label="Details" />
                            <StyledTableCell label=" " />

                        </StyledTableRow>
                    </TableHead>
                    <TableBody>
                        {applications?.Records?.length > 0 && applications.Records.map((row) => (
                            <StyledTableRow key={row.username}>
                                <StyledTableCell label={row.applicationName} />
                                <StyledTableCell   >
                                    {row.applicationDetails.length > 0 ?
                                        <Typography style={{ fontWeight: 'bold' }} color={row.applicationDetails[0].detailValue === "true" ? 'primary' : 'error'}>
                                            {row.applicationDetails[0].detailValue === "true" ? 'Authorized' : 'Unauthorized'}
                                        </Typography> : "N/A"}
                                </StyledTableCell>
                                <StyledTableCell align="right"  >
                                    <IconButton color='primary' style={{ marginRight: '30px' }} onClick={() => { setSelectedApplication(row); setOpenEditApplication(true) }}>
                                        <BsFillPencilFill />
                                    </IconButton>
                                    <IconButton color='primary' style={{ marginRight: '30px' }} onClick={() => { setSelectedApplication(row); setOpenHistoryApplication(true) }}>
                                        <FaHistory />
                                    </IconButton>
                                </StyledTableCell>
                            </StyledTableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer> : (<Loader />)}

            <DialogContainer
                open={openEditApplication}
                handleClose={handleCloseDialog}
            >
                <AppEdit
                    selectedApplication={selectedApplication}
                    handleClose={handleCloseDialog} />
            </DialogContainer>
            <DialogContainer
                open={openHistoryApplication}
                handleClose={handleCloseDialog}
            >
                <ApplicationHistory
                    selectedApplication={selectedApplication}
                    handleClose={handleCloseDialog} />
            </DialogContainer>
        </>
    )

}


export default AppsList;